import { z } from 'zod'

export const workTaskTrackerAdminResponseSchema = z.object({}).passthrough()
export type WorkTaskTrackerAdminResponse = z.infer<typeof workTaskTrackerAdminResponseSchema>
